module.exports = __webpack_public_path__ + "img/product_127.26d614f.jpg";